module.exports = __webpack_public_path__ + "img/clear_6.3227d21c.jpg";